import { Box, Typography } from "@mui/material";
import { t } from "./coachTokens";

// Single name-cell renderer shared across every dashboard tab. Mirrors the
// clients page (name + email subline) so the two surfaces look alike.
const ClientAvatar = ({ name, email, phone }) => {
  const subline = email || phone || "—";
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, minWidth: 0 }}>
      <Box sx={{ overflow: "hidden", minWidth: 0 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: t.text, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {name}
        </Typography>
        <Typography sx={{ fontSize: 11, color: t.t3, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
          {subline}
        </Typography>
      </Box>
    </Box>
  );
};

export default ClientAvatar;
